import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import SystemsData from '../data/systems/SystemsData.json';

const SystemDetails = () => {
  const { slug } = useParams();
  const system = SystemsData.find((s) => s.slug === slug);

  if (!system) {
    return <Navigate to={process.env.PUBLIC_URL + '/'} replace />;
  }

  const pdfUrl = process.env.PUBLIC_URL + system.pdfFile;

  return (
    <>
      <SEO title={system.title} />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title={system.title} page="المنظومات" />
        <div className="section-padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-11">
                <div className="section-heading text-center mb--50">
                  <h2 className="title">{system.title}</h2>
                  <p className="subtitle">{system.description}</p>
                  <a
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="axil-btn btn-fill-primary mb-4"
                  >
                    تحميل الشرح
                  </a>
                </div>
                <div
                  className="system-pdf-viewer"
                  style={{
                    width: '100%',
                    height: '80vh',
                    minHeight: '600px',
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }}
                >
                  <iframe
                    title={system.title}
                    src={pdfUrl + '#view=FitH'}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default SystemDetails;
